import {useLoader} from '../context/LoaderContext'

const usePageLoader = () => {
    const {isLoading, setIsLoading} = useLoader()

    const showLoader = () => setIsLoading(true)

    const hideLoader = () => setIsLoading(false)

    const toggleLoader = () => setIsLoading((prev) => !prev)

    return {
        isLoading,
        showLoader,
        hideLoader,
        toggleLoader,
        setIsLoading,
    }
}

export default usePageLoader
